import React from 'react';
import PropTypes from 'prop-types';

import IconLock from './svg/IconLock';

function AvatarLock({ className, style, color }) {
  const myStyle = {
    ...style,
    border: `1.5px solid ${color}`
  }
  return <IconLock className={'avatar-pm lock'} style={myStyle} />
}

AvatarLock.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string.isRequired
}

export default AvatarLock;
